import { displayPartyCompanyDefaultName, displayPartyPersonName } from './form/display-ts';

export const getCurrentVersionLabel = (version = '', prefix = '') => {
  return version.replace(prefix, '').replace(/[.-]hotfix.+$/, '');
};

export const getPartyDisplayName = opt => {
  if (opt.type === 'company') return displayPartyCompanyDefaultName(opt);

  const fullName = displayPartyPersonName(opt);

  if (fullName) {
    return fullName;
  } else if (opt.first_name || opt.last_name) {
    return `${opt.first_name} ${opt.last_name}`;
  } else {
    return opt.name || '';
  }
};

export const getAiportOptionLabel = option =>
  !option.name.endsWith(` - ${option.iata_code}`)
    ? `${option.name} - ${option.iata_code}`
    : option.name;

export const getCaptainReportTypeName = cptReportType =>
  (cptReportType || '-').split('_').join(' ');
